import api from '@/js/services/axios'
import ClassRepository, { ACCESS_TYPES, PAYMENT_MODES } from '../ClassRepository'

export { PAYMENT_MODES, ACCESS_TYPES }

export default {
  getAll () {
    return new Promise((resolve, reject) => {
      api.get('private/v1/org/{orgId}/classes')
        .then(response => {
          var data = response.data
          data.map(myClass => {
            myClass = this._processMyClass(myClass)
            return myClass;
          });
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateClass (myClass){
    return new Promise((resolve, reject) => {
      let myClassDto = this._prepareMyClassObject(myClass)
      api.patch('private/v1/org/{orgId}/classes/' + myClass.id, myClassDto)
        .then(response => {
          var data = this._processMyClass(response.data)
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  createClass (myClass){
    return new Promise((resolve, reject) => {
      let myClassDto = this._prepareMyClassObject(myClass)
      api.post('private/v1/org/{orgId}/classes', myClassDto)
        .then(response => {
          var data = this._processMyClass(response.data)
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  deleteClass (classId){
    return new Promise((resolve, reject) => {
      api.delete('private/v1/org/{orgId}/classes/' + classId)
        .then(() => {
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAvailableImages() {
    return new Promise((resolve, reject) => {
      api.get('private/v1/org/{orgId}/s3/images')
        .then(response => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  /** Function prepares myClass object for API call. */
  _prepareMyClassObject(myClass){
    if (!myClass){
      return null;
    }

    const dto = {
      name: myClass.name,
      cover: myClass.cover,
      description: myClass.description,
      place: myClass.place,
      price: myClass.price,
      price_text: myClass.price_text,
      participant_limit: myClass.participant_limit,
      sequence: myClass.sequence,
      trainer: myClass.trainer,
      color_code: myClass.color_code,
      close_signup_before_minutes: myClass.close_signup_before_minutes,
      duration_minutes: myClass.duration_minutes,
      show_available_spots: myClass.show_available_spots,
      with_attendee: myClass.with_attendee,
      messages: myClass.messages,
      class_type: myClass.class_type,
      access_type: myClass.access_type || null,
      payment_mode: myClass.payment_mode || null,
      class_settings: myClass.class_settings && typeof myClass.class_settings === 'object' ? myClass.class_settings : undefined
    }
    if (myClass.access_type === ACCESS_TYPES.PRIVATE_WITH_TAGS && myClass.access_client_tags != null) {
      dto.access_client_tags = Array.isArray(myClass.access_client_tags)
        ? JSON.stringify(myClass.access_client_tags)
        : myClass.access_client_tags
    } else {
      dto.access_client_tags = null
    }
    return dto
  },

  _processMyClass(myClass) {
    myClass = ClassRepository._processMyClass(myClass)

    if (myClass.messages) {
      myClass.messages = JSON.parse(myClass.messages)
    }
    if (myClass.access_client_tags != null && typeof myClass.access_client_tags === 'string') {
      try {
        myClass.access_client_tags = JSON.parse(myClass.access_client_tags)
      } catch (e) {
        myClass.access_client_tags = []
      }
    }
    if (myClass.access_client_tags == null) {
      myClass.access_client_tags = []
    }
    if (myClass.class_settings != null && typeof myClass.class_settings === 'string') {
      try {
        myClass.class_settings = JSON.parse(myClass.class_settings)
      } catch (e) {
        myClass.class_settings = {}
      }
    }
    if (myClass.class_settings == null) {
      myClass.class_settings = {}
    }
    return myClass
  }
}
